// extracted by mini-css-extract-plugin
export default {"link":"Notices_link__9E9X3","primary":"Notices_primary__QmD6O","sentence":"Notices_sentence__OVX1s","help":"Notices_help__m9q7Z"};